import { Component, OnInit, Inject, ViewChild, ElementRef, OnDestroy, ViewChildren, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UtilService, FundraiserService, VariablesService } from '../../../../shared/services';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { loading_gif } from '../../../../fundraiser/models/image-loader';
import { IUser } from '../../../../shared/models';
import { Subscription } from 'rxjs';
import { IFacebook } from '../../../../shared/models/fb.model';
import { CaptchaInputComponent } from '../../../captcha-input/components/captcha-input/captcha-input.component';

@Component({
  selector: 'app-start-supporting-fr',
  templateUrl: './start-supporting-fr.component.html',
  styleUrls: ['./start-supporting-fr.component.scss']
})
export class StartSupportingFrComponent implements OnInit, OnDestroy {

  startFRForm: FormGroup;
  amount: FormControl;
  appeal: FormControl;
  captcha: FormControl;
  currencies = [
    'INR'
  ];
  userdata: IUser;
  userdataSubs: Subscription;
  @ViewChild('profilePic', { static: true }) public profilePic: ElementRef<HTMLInputElement>;
  @ViewChild('profileSrcRef', { static: true }) public profileSrcRef: ElementRef<HTMLInputElement>;
  @ViewChild('fbLogin', { read: ElementRef, static: true }) public fbLogin: ElementRef<any>;
  @ViewChild('captchaRef', { static: true }) public captchaRef: CaptchaInputComponent;
  disableStartFR = false;
  constructor(
    public fundraiserService: FundraiserService,
    public variablesService: VariablesService,
    public utilService: UtilService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.startFRForm = new FormGroup({
      amount: this.amount = new FormControl('', [
        Validators.required, Validators.min(2000), Validators.max(50000000), Validators.pattern(/^[0-9]*$/)
      ]),
      appeal: this.appeal = new FormControl('', [Validators.required, Validators.minLength(5), Validators.max(800)]),
      captcha: this.captcha = new FormControl('', [Validators.required])
    });
    this.userdataSubs = this.variablesService.userData.subscribe({ next: res => this.userdata = res });
  }

  openFileUpload() {
    this.profilePic.nativeElement.value = '';
    this.profilePic.nativeElement.click();
  }
  /**facebook connect and get the data to update
   * the profile pic
   */
  facebookConnect() {
    this.fbLogin.nativeElement.firstChild.click();
  }
  /**Get the facebook response*/
  getFbResponse(data: IFacebook | any) {
    this.fundraiserService.getFbProfilePic(data.userID).subscribe((res: any) => {
      Object.assign(this.userdata.avtar, {
        cdn_path: res
      });
      this.profileSrcRef.nativeElement.src = res;
    });
  }
  /**File change event for uploading file */
  fileChangeEvent(event: any): void {
    const file: File = event.target.files[0];
    const error = this.utilService.onFileChange(event);
    if (!error.error) {
      this.userdata.avtar = { cdn_path: this.utilService.defaultBlurImg };
      this.profileSrcRef.nativeElement.src = loading_gif;
      this.fundraiserService.uploadProfilePic(this.userdata.id, file).subscribe((res: any) => {
        // this.donor.donoravtar = {
        //   cdn_path: res.cdn_path
        // };
        this.profileSrcRef.nativeElement.src = res.cdn_path;
        this.userdata.avtar = { cdn_path: res.cdn_path };
      }, () => {
        // this.profileSrcRef.nativeElement.src = this.donor.donoravtar.cdn_path;
      });
    }
  }
  /**Submit the form */
  submit(template: TemplateRef<any>) {
    this.disableStartFR = true;
    if (this.startFRForm.valid) {
      const payload = {
        'amount_requested': this.amount.value,
        'appeal': this.appeal.value,
        'g-recaptcha-response': this.captcha.value
      };
      this.starNewSupportingFundraiser(payload, template);
    } else {
      this.disableStartFR = false;
      this.utilService.checkValidForm(this.startFRForm);
    }
  }
  /**create new supporting fundraiser */
  starNewSupportingFundraiser(payload, template: TemplateRef<any>) {

    this.fundraiserService.startSupprtingFr(this.data.id, payload).subscribe((res: any) => {
      // this.utilService.openSnackBar('Your supported fundraiser craeted successfully', 'success');
      this.dialog.closeAll();
      this.disableStartFR = false;
      const supportFr = res.data;
      // const url = `${this.utilService.domain_details.domain_url}/supportfundraiser/${supportFr.custom_tag}#/shareSupportingFrModal`;
      this.openDialogWithTemplateRef(template);
    }, () => {
      this.captchaRef.resetCaptcha();
      this.disableStartFR = false;
    });
  }

  openDialogWithTemplateRef(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      maxWidth: '100vw',
      width: this.utilService.isMobile() ? '340px' : '600px',
      height: this.utilService.isMobile() ? '235px' : '196px',
      panelClass: 'dialog-class'
    });
  }

  closeDialog() {
    this.dialog.closeAll();
    const url = `${this.utilService.domain_details.domain_url}/fundraiser/${this.variablesService.fundraiser.custom_tag}`;
    this.utilService.nativeNavigation(url);
  }

  ngOnDestroy() {
    if (this.userdataSubs) { this.userdataSubs.unsubscribe(); }
  }

}
